/**
 * 영수증 데이터에서 여러 소스의 바코드 데이터를 수집하는 유틸리티 함수
 *
 * 수집 순서:
 * 1. prk_brcd_data (단일 문자열 또는 배열)
 * 2. med_rsv 배열의 각 항목의 brcd_data
 * 3. place_to_go 배열의 각 항목의 brcd_data
 * 4. drug_voucher.brcd_data
 *
 * @param {Object} receiptData - 영수증 데이터 객체
 * @returns {string[]} 최대 3개의 바코드 데이터 배열
 */
export const collectBarcodeData = (receiptData) => {
  if (!receiptData) return [];

  const barcodes = [];

  // 1. prk_brcd_data 수집 (단일 문자열 또는 배열)
  if (receiptData.prk_brcd_data) {
    barcodes.push(receiptData.prk_brcd_data);
  }

  // 2. place_to_go 배열에서 수집
  if (receiptData.place_to_go?.length) {
    barcodes.push(receiptData.place_to_go[0].brcd_data);
  }

  // 3. drug_voucher에서 수집
  if (receiptData.drug_voucher?.brcd_data && barcodes.length < 4) {
    barcodes.push(receiptData.drug_voucher.brcd_data);
  }

  // 4. med_rsv 배열의 각 항목의 brcd_data에서 수집
  if (receiptData.med_rsv?.length) {
    barcodes.push(receiptData.med_rsv[0].brcd_data);
  }

  return barcodes;
};
